import countdown from "countdown";
import { setCookie, getCookie, delCookie, forceInt  } from "../functions";

$(function() {
    const headerACCBanner = $('.header-acc-banner'),
        cookieName = 'HPAAutoCouponCode',
        days = 0.25,
        durationMs = 60*60*24*1000*days,
        hpaFirstVisitCookieName = 'HPAFirstVisit',
        hpaFirstVisitCookieDays = (365*99); // 99 years

    if (!getCookie(hpaFirstVisitCookieName)) {
        let firstVisitTimestamp = new Date().getTime();

        if (gtmMemberData && ('created' in gtmMemberData)) { // added this after the banner had been disabled for a while so still need the code within headerACCBanner.each( incase they already have a cookie but weren't logged in.
            firstVisitTimestamp = Date.parse(gtmMemberData.created);
        }

        setCookie(hpaFirstVisitCookieName, firstVisitTimestamp, hpaFirstVisitCookieDays);
    }

    if (headerACCBanner.length) {
        headerACCBanner.find('.close-cross').on('click touch', function() {
            const $this = $(this),
                parent = $this.parent(),
                acc = parent.data('acc'),
                storageName = 'HPA_ACC_' + acc;

            parent.hide();
            sessionStorage.setItem(storageName + '_Closed', true);
        });

        headerACCBanner.each(function() {
            const $this = $(this),
                acc = $this.data('acc'),
                status = forceInt($this.data('status')),
                coundownTimerEl = $this.find('.haccb-countdown-timer'),
                storageName = 'HPA_ACC_' + acc,
                date = new Date(),
                isClosed = sessionStorage.getItem(storageName + '_Closed'),
                cookieValue = getCookie(cookieName);

            let firstVisitTimestamp = getCookie(hpaFirstVisitCookieName);
            if (firstVisitTimestamp !== null) {
                firstVisitTimestamp = forceInt(firstVisitTimestamp);
                if (gtmMemberData && ('created' in gtmMemberData)) {
                    const memberCreatedMs = Date.parse(gtmMemberData.created);
                    if (memberCreatedMs < firstVisitTimestamp) {
                        setCookie(hpaFirstVisitCookieName, memberCreatedMs, hpaFirstVisitCookieDays);
                    }
                }
            }

            let showBanner = true,
                applyDiscount = true;

            if (isClosed) {
                showBanner = false;
            }

            if (status === 0) {
                applyDiscount = false;
            } else if (gtmMemberData !== false) { // Don't apply discount if they are logged in
                applyDiscount = false;
            } else if (!firstVisitTimestamp || ((date.getTime() - firstVisitTimestamp) > durationMs)) {
                applyDiscount = false;
            } else if (cookieValue && cookieValue != acc) {
                applyDiscount = false;
            } else if ($('.VIPSignupPage_tvar98').length) {
                applyDiscount = false;
            }

            if (!applyDiscount) {
                if (cookieValue == acc) delCookie(cookieName);
            } else {
                if (!cookieValue) {
                    // Uncomment when test is finished
                    setCookie(cookieName, acc, days);
                }
            }

            globalNmdShowBanner = showBanner;
            globalNmdApplyDiscount = applyDiscount;

            if (showBanner && applyDiscount) {
                countdownTimer((firstVisitTimestamp + durationMs), coundownTimerEl, function() {
                    if (getCookie(cookieName) == acc) delCookie(cookieName);
                });
                // Uncomment when test is finished
                $this.show();
            }

        });

        function countdownTimer(endTimestamp, coundownTimerEl, onEndFunc) {
            if (coundownTimerEl.length) {
                let value = hpaTranslatedtext.headerACCBanner.saleHasEnded; // Sale has ended
                if (endTimestamp > Date.now()) {
                    value = countdown(new Date(endTimestamp)).toString();
                    setTimeout(function() {
                        countdownTimer(endTimestamp, coundownTimerEl, onEndFunc);
                    }, 1000);
                } else {
                    onEndFunc();
                }
                coundownTimerEl.text(value);
            }
        }

    }

    // const $homeBannerInner = $('.home-banner-inner');
    // if ($homeBannerInner.length) $homeBannerInner.css('visibility', 'visible');

    // Language Toggle Alert
    $(".dropdown-btn").click(function () {
        var $parent = $(this).parent();
        $parent.toggleClass("language-dropdown--active");
    });

    const $siteHeader = $('.site-header');
    if ($siteHeader.length) {
        const pageId = forceInt($siteHeader.data('pid')),
            $activeMenuItem = $siteHeader.find('a[data-menu-page-id="' + pageId + '"]');

        if ($activeMenuItem.length) {
            $activeMenuItem.addClass('active');
        }
    }

});



// WEBPACK FOOTER //
// ./js/modules/header.js